export const FormRegistrationPhoneNumberTranslationsCs = {
  phoneNumberLabel: 'Číslo telefonu',
  phoneNumberPlaceholder: '+420',
  phoneNumberErrorMessage: 'Zadejte platné telefonní číslo',
  passwordLabel: 'Heslo',
  passwordPlaceholder: '****',
  passwordErrorMessage: 'Zadejte platné heslo',
  privacyPolicyText: 'Kliknutím na Registrovat souhlasíte s',
  privacyPolicyLinkText: 'Podmínkami ochrany osobních údajů',
  registerButton: 'Registrovat',

  // error
  'Required field': 'Povinné pole',
  'Invalid phone number format': 'Neplatný formát telefonního čísla',
  'Password must be at least 8 characters':
    'Heslo musí obsahovat alespoň 8 znaků',
  'Password must be less than 32 characters':
    'Heslo musí mít méně než 32 znaků',
  'Password must contain at least 8 Latin characters, one uppercase letter, one digit':
    'Heslo musí obsahovat alespoň 8 latinských znaků, jedno velké písmeno a jednu číslici',

  // errors back-end
  'Phone number in use': 'Telefonní číslo je již používáno',
};
